import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DoughnutChartOperatorsSendingComponent } from './doughnut-chart-operators-sending/doughnut-chart-operators-sending.component';
import { BaseDoughnutChartComponent } from './base-doughnut-chart/base-doughnut-chart.component';
import { DoughnutChartTodayComponent } from './doughnut-chart-today/doughnut-chart-today.component';
import { DoughnutChartStatisticsByPartLengthComponent } from './doughnut-chart-statistics-by-part-length/doughnut-chart-statistics-by-part-length.component';
import { DoughnutChartSendSmartSmsDetailsByDeliveryComponent } from './doughnut-chart-send-smart-sms-details-by-delivery/doughnut-chart-send-smart-sms-details-by-delivery.component';
import { DoughnutChartSendDetailsStatsComponent } from './doughnut-chart-send-details-stats/doughnut-chart-send-details-stats.component';
import { DoughnutChartOperatorStatisticsComponent } from './doughnut-chart-operator-statistics/doughnut-chart-operator-statistics.component';
import { DoughnutChartSentCountAggregateCompareStatisticsComponent } from './doughnut-chart-sent-count-aggregate-compare-statistics/doughnut-chart-sent-count-aggregate-compare-statistics.component';
import { DoughnutChartSentCountSeasonsCompareStatisticsComponent } from './doughnut-chart-sent-count-seasons-compare-statistics/doughnut-chart-sent-count-seasons-compare-statistics.component';

@NgModule({
  declarations: [
    BaseDoughnutChartComponent,
    DoughnutChartOperatorsSendingComponent,
    DoughnutChartTodayComponent,
    DoughnutChartStatisticsByPartLengthComponent,
    DoughnutChartSendSmartSmsDetailsByDeliveryComponent,
    DoughnutChartSendDetailsStatsComponent,
    DoughnutChartOperatorStatisticsComponent,
    DoughnutChartSentCountAggregateCompareStatisticsComponent,
    DoughnutChartSentCountSeasonsCompareStatisticsComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BaseDoughnutChartComponent,
    DoughnutChartOperatorsSendingComponent,
    DoughnutChartTodayComponent,
    DoughnutChartStatisticsByPartLengthComponent,
    DoughnutChartSendSmartSmsDetailsByDeliveryComponent,
    DoughnutChartSendDetailsStatsComponent,
    DoughnutChartOperatorStatisticsComponent,
    DoughnutChartSentCountAggregateCompareStatisticsComponent,
    DoughnutChartSentCountSeasonsCompareStatisticsComponent,
  ]
})

export class DoughnutChartModule { }
